import { createAvatar } from '@dicebear/core';
import {
  adventurer,
  avataaars,
  bottts,
  lorelei,
  micah,
  toonHead,
  openPeeps,
} from '@dicebear/collection';

// Default options align with profile page
const DEFAULT_AVATAR_OPTIONS = {
  radius: 50,
  backgroundColor: ['b6e3f4', 'c0aede', 'd1d4f9', 'ffd5dc', 'ffdfbf'],
  // Keep IDs stable to avoid new SVG hashes causing image "blinks"
  randomizeIds: false,
};

const COLLECTION_MAP: Record<string, any> = {
  adventurer,
  avataaars,
  bottts,
  lorelei,
  micah,
  'toon-head': toonHead,
  toonhead: toonHead,
  toonHead,
  toonHead: toonHead,
  'open-peeps': openPeeps,
  openpeeps: openPeeps,
  openPeeps,
  openPeeps: openPeeps,
};

const normalizeCollection = (name?: string | null) => {
  if (!name) return 'adventurer';
  const key = name.trim();
  const lower = key.toLowerCase();
  if (lower === 'toonhead' || lower === 'toon-head' || key === 'toonHead') return 'toon-head';
  if (lower === 'openpeeps' || lower === 'open-peeps' || key === 'openPeeps') return 'open-peeps';
  return key;
};

// Memoize to keep identical data URIs between renders
const cache = new Map<string, string>();

export const buildAvatarDataUri = (collectionName?: string | null, seed?: string | null) => {
  if (!seed) return undefined;
  const normalized = normalizeCollection(collectionName);
  const cacheKey = `${normalized}|${seed}`;
  const cached = cache.get(cacheKey);
  if (cached) return cached;
  const collection = COLLECTION_MAP[normalized] || COLLECTION_MAP[normalized.toLowerCase()] || adventurer;
  try {
    const svg = createAvatar(collection, {
      ...DEFAULT_AVATAR_OPTIONS,
      seed,
    }).toString();
    const uri = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
    cache.set(cacheKey, uri);
    return uri;
  } catch (error) {
    console.warn('Failed to build avatar', collectionName, seed, error);
    return undefined;
  }
};

export const getCollectionNameNormalized = normalizeCollection;
